<template>
  <nav
    class="fixed-right navbar navbar-vertical navbar-expand-xs navbar-light bg-white"
    id="sidenav-filters"
    v-click-outside="handleClose"
  >
    <div class="row">
      <div class="col-12">
        <i
          class="fas fa-times fa-close p-1 text-primary"
          title="Fechar"
          @click="handleClose()"
        ></i>
      </div>
      <div
        class="col-12 mt-4 text-center vld-parent"
        ref="evaluation_container"
      >
        <i class="fas fa-tasks fa-3x"></i>
        <h4 class="mt-3">{{ material.title }}</h4>
        <p class="description text-center mb-0">
          {{ material.description }}
        </p>
        <div class="mt-4 text-left">
          <h6 class="heading-small text-muted mb-3">Perguntas</h6>
          <div class="ml-1" v-for="question in questions" :key="question.id">
            <label class="form-control-label d-block">
              {{ question.title }}</label
            >
            <p class="description ml-2">{{ question.description }}</p>
            <base-input v-if="question.type === 'text'">
              <textarea
                v-model="model.answers[question.id]"
                class="form-control"
                placeholder="Escreva sua resposta aqui..."
                rows="2"
                :disabled="!!question.answer"
              ></textarea>
            </base-input>
            <div v-if="question.type === 'radiobox'">
              <base-input>
                <base-radio
                  v-for="(option, index) in question.options"
                  :key="`question_${question.id}_radiobox_${index}`"
                  v-model="model.answers[question.id]"
                  :name="String(index)"
                  :inline="false"
                  :disabled="!!question.answer"
                  class="mb-2 ml-2"
                >
                  <span class="ml--2"
                    >{{ option.title }}
                    <span
                      class="mx-2"
                      v-if="
                        question.answer && question.answer.right_answer !== ''
                      "
                      ><i
                        v-if="
                          String(question.answer.right_answer) === String(index)
                        "
                        class="fas fa-check text-success"
                      />
                      <i
                        v-else-if="
                          String(model.answers[question.id]) === String(index)
                        "
                        class="fas fa-times text-danger"
                      />
                    </span>
                  </span>
                </base-radio>
              </base-input>
            </div>
            <div v-if="question.type === 'checkbox'">
              <base-input>
                <base-checkbox
                  v-for="(option, index) in question.options"
                  :key="`question_${question.id}_checkbox_${index}`"
                  @input="handleCheckboxSelected(question.id, index, $event)"
                  :inline="false"
                  class="mb-2 ml-2"
                  :checked="
                    model.answers[question.id]
                      ? model.answers[question.id].includes(index)
                      : false
                  "
                  :disabled="!!question.answer"
                >
                  <span class="ml--2"
                    >{{ option.title }}
                    <span
                      class="mx-2"
                      v-if="
                        question.answer && question.answer.right_answer !== ''
                      "
                      ><i
                        v-if="question.answer.right_answer.includes(index)"
                        class="fas fa-check text-success"
                      />
                      <i
                        v-else-if="model.answers[question.id].includes(index)"
                        class="fas fa-times text-danger"
                      />
                    </span>
                  </span>
                </base-checkbox>
              </base-input>
            </div>
            <hr class="my-4" />
          </div>
        </div>
        <div class="text-center" v-if="!hasAnswer">
          <base-button
            type="primary"
            :custom="true"
            :disabled="!isValidModel()"
            @click="handleOpenModalConfirmation"
            >Enviar respostas</base-button
          >
        </div>
        <div class="text-center" v-else-if="hasEmptyAnswer">
          <base-button
            type="primary"
            :custom="true"
            :disabled="!isValidModel()"
            @click="handleOpenModalConfirmation"
            >Enviar respostas às novas perguntas</base-button
          >
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalConfirmation.show"
      modal-classes="modal-default modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation">
        <div class="py-3 text-center">
          <i class="fa fa-tasks fa-3x"></i>
          <h4 class="heading mt-4">Confirmar envio</h4>
          <p class="mt-3 mb-0">
            Você realmente deseja enviar sua resposta? Uma vez submetido, sua
            resposta não poderá ser alterada. Certifique-se de ter respondido
            corretamente todas as questões.
          </p>
        </div>
        <base-alert
          type="danger"
          class="text-center mb-0"
          v-if="modalConfirmation.error"
          >{{ modalConfirmation.error }}</base-alert
        >
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modalConfirmation.show = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white text-success"
          @click="handleSubmitResponse"
          :disabled="!isValidModel()"
        >
          Confirmar envio
        </base-button>
      </template>
    </modal>
  </nav>
</template>
<script>
import api from "@/services/api";

export default {
  props: {
    material: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      model: {
        answers: {},
      },
      questions: [],
      hasAnswer: false,
      hasEmptyAnswer: false,
      modalConfirmation: {
        show: false,
        error: "",
      },
    };
  },
  async mounted() {
    await this.handleMaterialChanged();
  },
  methods: {
    async handleMaterialChanged() {
      const loader = this.$loading.show({
        container: this.$refs.evaluation_container,
        width: 100,
        height: 100,
      });
      try {
        const { data } = await api.get(
          `/startup/courses/${this.material.course_id}/answers/${this.material.id}`
        );
        const questions = [];
        this.material.evaluation.forEach((evaluation) => {
          if (
            (typeof evaluation.options === "string" ||
              evaluation.options instanceof String) &&
            ["radiobox", "checkbox"].includes(evaluation.type)
          ) {
            evaluation.options = JSON.parse(evaluation.options);
          }
          const answer = data.find(
            (answer) => answer.evaluation_id === evaluation.id
          );
          if (answer) {
            this.hasAnswer = true;
            answer.rigth_answer = this.getFormattedAnswer(
              answer,
              evaluation.type
            );
            evaluation.answer = answer;
            this.model.answers[answer.evaluation_id] = this.getFormattedAnswer(
              answer,
              evaluation.type
            );
          } else this.hasEmptyAnswer = true;
          questions.push(evaluation);
        });
        this.questions = questions;
        loader.hide();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar as informações!");
      }
    },
    handleClose() {
      this.$emit("closeEvaluation");
    },
    handleCheckboxSelected(questionId, checkboxIndex, event) {
      let answer = this.model.answers[questionId] || [];
      if (event) {
        if (!answer.includes(checkboxIndex)) {
          answer.push(checkboxIndex);
        }
      } else {
        answer = answer.filter((idx) => idx !== checkboxIndex);
      }
      this.$set(this.model.answers, questionId, answer);
    },
    handleOpenModalConfirmation() {
      this.modalConfirmation.show = true;
    },
    async handleSubmitResponse() {
      this.modalConfirmation.error = "";
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation,
        width: 90,
        height: 90,
        opacity: 0,
        color: "white",
      });
      try {
        const { data } = await api.post(
          `/startup/courses/${this.material.course_id}/answers/${this.material.id}`,
          { answers: this.model.answers }
        );
        this.hasEmptyAnswer = false;
        this.material.evaluation.forEach((evaluation) => {
          const answer = data.find(
            (answer) => answer.evaluation_id === evaluation.id
          );
          if (answer) {
            this.hasAnswer = true;
            answer.rigth_answer = this.getFormattedAnswer(
              answer,
              evaluation.type
            );
            evaluation.answer = answer;
          } else this.hasEmptyAnswer = true;
        });
        this.material.startupMaterial = {
          material_id: this.material.id,
        };
        this.$toasted.show("Resposta enviada com sucesso.");
        this.modalConfirmation.show = false;
      } catch (e) {
        this.modalConfirmation.error =
          "Ocorreu um erro ao submeter a resposta. Por favor, tente novamente em alguns instantes";
        this.$toasted.error("Ocorreu um erro ao submeter a resposta.");
      }
      loader.hide();
    },
    async setViewed() {
      if (this.material.startupMaterial) return;
      try {
        const { data } = await api.put(
          `/startup/courses/${this.material.course_id}/materials/${this.material.id}/set-viewed`
        );
        this.material.startupMaterial = data;
      } catch (e) {
        this.$toasted.error("Progesso não pode ser salvo.");
      }
    },
    getFormattedAnswer(answer, type) {
      if (!answer) return;
      let content = answer.answer;
      if (type === "checkbox") {
        try {
          content = content.split(",").map((option) => parseInt(option));
        } catch (e) {
          content = "";
        }
      }
      return content;
    },
    isValidModel() {
      if (this.questions.length !== Object.keys(this.model.answers).length)
        return false;
      for (const key of Object.keys(this.model.answers)) {
        if (this.model.answers[key] === "" || !this.model.answers[key].length) {
          return false;
        }
      }
      return true;
    },
  },
  watch: {
    material: async function () {
      await this.handleMaterialChanged();
    },
  },
};
</script>
<style scoped>
.navbar {
  z-index: 1000 !important;
}
.navbar-vertical.navbar-expand-xs {
  width: 100%;
  max-width: 750px !important;
}
.fa-close {
  font-size: 1.5em;
  cursor: pointer;
}
</style>
